import React from "react";
import {
	AutocompleteInput,
	NumberInput,
	ReferenceInput,
	required,
	SelectInput,
	SimpleForm,
} from "react-admin";
import { bookmakersConfig } from "../bookmakers";

const Form = (props) => {
	return (
		<SimpleForm {...props} redirect="list">
			<ReferenceInput
				source="contest_id"
				fullWidth
				reference="contests"
				resettable
				validate={required()}
			>
				<SelectInput optionText="title" />
			</ReferenceInput>
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				filter={{ status: "active" }}
				{...bookmakersConfig.reference}
				validate={required()}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
			<NumberInput source="cpa_value" validate={required()} defaultValue="1" />
		</SimpleForm>
	);
};
export default Form;
